<template>
  <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>进货系统</el-breadcrumb-item>
      <el-breadcrumb-item>进货记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!--卡片视图区域-->
    <el-card>
      <!--筛选区域：每个筛选项前面加上名称-->
      <el-form :inline="true" :model="queryInfo" class="search-form">
        <el-form-item label="厂家：">
          <el-input
            placeholder="厂家"
            v-model="queryInfo.query"
            clearable
            style="width: 80px"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="类型：">
          <el-select
            v-model="queryInfo.typeIngoods"
            placeholder="请选择"
            clearable
            style="width: 65px"
            size="mini"
            @change="handleTypeChange"
          >
            <el-option label="紫铜" value="紫铜"></el-option>
            <el-option label="黄铜" value="黄铜"></el-option>
            <el-option label="铜包铜" value="铜包铜"></el-option>
            <el-option label="成品" value="成品"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库时间：">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始"
            end-placeholder="结束"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 155px"
            size="mini"
            @change="handleDateRangeChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getUserList" size="mini">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetSearch" size="mini">重置</el-button>
        </el-form-item>
      </el-form>

      <!--操作与统计栏-->
      <el-row :gutter="20" class="action-bar">
        <el-col :span="8">
          <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" size="small">添加记录</el-button>
        </el-col>
        <el-col :span="16" class="stats-col">
          <el-tag type="success" size="small" effect="plain">
            <i class="el-icon-s-data"></i> 总重量：<strong>{{ totalArrivalIngoodsNum }}</strong> 吨
          </el-tag>
          <el-tag type="info" size="small" effect="plain" style="margin-left: 6px;">
            共 <strong>{{ total }}</strong> 条记录
          </el-tag>
        </el-col>
      </el-row>

      <!--用户表格区域-->
      <el-table
          border
          :data="userList"
          stripe
          size="small"
          class="ingoods-table">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="arrivalIngoodsTime" label="入库时间" width="105"></el-table-column>
        <el-table-column prop="typeIngoods" label="类型" width="70"></el-table-column>
        <el-table-column prop="arrivalIngoodsNum" label="数量（kg）" width="95"></el-table-column>
        <el-table-column prop="priceIngoods" label="单价（元）" width="95"></el-table-column>
        <el-table-column prop="priceIngoodsSum" label="总价（元）" width="100"></el-table-column>
        <el-table-column prop="factoryIngoods" label="厂家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="truckIngoods" label="运输方式" width="100"></el-table-column>
        <el-table-column prop="priceTruck" label="运费（元）" width="85"></el-table-column>
        <el-table-column prop="recordIngoodsTime" label="记录时间" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" fixed="right" class-name="compact-actions">
          <template v-slot:default="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" class="action-btn"
                       @click="updateUser(scope.row)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" class="action-btn"
                       @click="deleteUser(scope.row._id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页区域-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[1, 2, 5, 10]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          size="small">
      </el-pagination>
    </el-card>
    <!--添加用户对话框-->
    <el-dialog
        @close="addDialogClose"
        title="添加记录"
        :visible.sync="dialogVisible"
        width="40%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        >
      <el-form :model="userInfo" :rules="userInfoRules" ref="userInfoRef" label-width="100px">
        <!-- 入库时间 - 日期选择框 -->
        <el-form-item label="入库时间" prop="arrivalIngoodsTime">
          <el-date-picker
            v-model="userInfo.arrivalIngoodsTime"
            type="date"
            placeholder="选择入库日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <!-- 类型 - 下拉选项 -->
        <el-form-item label="类型" prop="typeIngoods">
          <el-select
            v-model="userInfo.typeIngoods"
            placeholder="请选择类型"
          >
            <el-option label="紫铜" value="紫铜"></el-option>
            <el-option label="黄铜" value="黄铜"></el-option>
            <el-option label="铜包铜" value="铜包铜"></el-option>
            <el-option label="成品" value="成品"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="arrivalIngoodsNum">
          <el-input v-model="userInfo.arrivalIngoodsNum" >
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">公斤</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="单价" prop="priceIngoods">
          <el-input v-model="userInfo.priceIngoods">
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
            </template>
          </el-input>
        </el-form-item>
                <el-form-item label="总价" prop="priceIngoodsSum">
          <el-input v-model="userInfo.priceIngoodsSum">
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
            </template>
          </el-input>
        </el-form-item>
        <!-- 厂家 - 下拉选项 -->
        <el-form-item label="厂家" prop="factoryIngoods">
          <el-select
            v-model="userInfo.factoryIngoods"
            placeholder="请选择厂家"
          >
            <el-option label="文安｜王胖子" value="文安｜王胖子"></el-option>
            <el-option label="广东｜铜包铜" value="广东｜铜包铜"></el-option>
            <el-option label="天津｜新能" value="天津｜新能"></el-option>
            <el-option label="天津｜亿万城" value="天津｜亿万城"></el-option>
            <el-option label="芜湖｜楚江" value="芜湖｜楚江"></el-option>
            <el-option label="芜湖｜长润" value="芜湖｜长润"></el-option>
            <el-option label="江西｜立泰" value="江西｜立泰"></el-option>
            <el-option label="宁晋｜一厂" value="宁晋｜一厂"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <!-- 运输 - 下拉选项 -->
        <el-form-item label="运输方式" prop="truckIngoods">
          <el-select
            v-model="userInfo.truckIngoods"
            placeholder="请选择运输方式"
          >
            <el-option label="货车｜大揪" value="货车｜大揪"></el-option>
            <el-option label="货车｜阿磊" value="货车｜阿磊"></el-option>
            <el-option label="线下约车" value="线下约车"></el-option>
            <el-option label="货拉拉" value="货拉拉"></el-option>
            <el-option label="包运到家" value="包运到家"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运费" prop="priceTruck">
          <el-input v-model="userInfo.priceTruck">
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>
    <!--编辑用户信息对话框-->
    <el-dialog
        @close="editDialogClose"
        title="修改记录"
        :visible.sync="editDialogVisible"
        width="40%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        >
      <el-form :model="updateUserInfo" :rules="userInfoRules" ref="editUserInfoRef" label-width="100px">
        <!-- 入库时间 - 日期选择框 -->
        <el-form-item label="入库时间" prop="arrivalIngoodsTime">
          <el-date-picker
            v-model="updateUserInfo.arrivalIngoodsTime"
            type="date"
            placeholder="选择入库日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <!-- 类型 - 下拉选项 -->
        <el-form-item label="类型" prop="typeIngoods">
          <el-select
            v-model="updateUserInfo.typeIngoods"
            placeholder="请选择类型"
          >
            <el-option label="紫铜" value="紫铜"></el-option>
            <el-option label="黄铜" value="黄铜"></el-option>
            <el-option label="铜包铜" value="铜包铜"></el-option>
            <el-option label="成品" value="成品"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="arrivalIngoodsNum">
          <el-input v-model="updateUserInfo.arrivalIngoodsNum" >
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">公斤</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="单价" prop="priceIngoods">
          <el-input v-model="updateUserInfo.priceIngoods">
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="总价" prop="priceIngoodsSum">
          <el-input v-model="updateUserInfo.priceIngoodsSum">
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
            </template>
          </el-input>
        </el-form-item>
        <!-- 厂家 - 下拉选项 -->
        <el-form-item label="厂家" prop="factoryIngoods">
          <el-select
            v-model="updateUserInfo.factoryIngoods"
            placeholder="请选择厂家"
          >
            <el-option label="文安｜王胖子" value="文安｜王胖子"></el-option>
            <el-option label="广东｜铜包铜" value="广东｜铜包铜"></el-option>
            <el-option label="天津｜新能" value="天津｜新能"></el-option>
            <el-option label="天津｜亿万城" value="天津｜亿万城"></el-option>
            <el-option label="芜湖｜楚江" value="芜湖｜楚江"></el-option>
            <el-option label="芜湖｜长润" value="芜湖｜长润"></el-option>
            <el-option label="江西｜立泰" value="江西｜立泰"></el-option>
            <el-option label="宁晋｜一厂" value="宁晋｜一厂"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <!-- 运输 - 下拉选项 -->
        <el-form-item label="运输方式" prop="truckIngoods">
          <el-select
            v-model="updateUserInfo.truckIngoods"
            placeholder="请选择运输方式"
          >
            <el-option label="货车｜大揪" value="货车｜大揪"></el-option>
            <el-option label="货车｜阿磊" value="货车｜阿磊"></el-option>
            <el-option label="线下约车" value="线下约车"></el-option>
            <el-option label="货拉拉" value="货拉拉"></el-option>
            <el-option label="包运到家" value="包运到家"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运费" prop="priceTruck">
          <el-input v-model="updateUserInfo.priceTruck">
            <template slot="suffix">
              <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const PUBTOOLS = require('../utils/pubtools');
import $httpREQUEST from '@/utils/request';
export default {
  name: "ingoods",
  data() {
    return {
      // 用户列表
      userList: [],
      // 获取用户列表查询参数
      queryInfo: {
        query: '',
        typeIngoods: '',
        startDate: '',
        endDate: '',
        pagenum: 1,
        pagesize: 5,
      },
      dateRange: [], // 入库时间范围
      totalArrivalIngoodsNum: '0.00', // 数量总量
      // 用户数据总条数
      total: 0,
      // 控制添加用户对话框显示和隐藏
      dialogVisible: false,
      // 控制添加用户对话框显示和隐藏
      editDialogVisible: false,
      // 用户信息
      userInfo: {
        // _id,_openid,// 记录id和记录人ip
        arrivalIngoodsNum: 0,//入库数量
        arrivalIngoodsTime: this.formatDateToYmd(),//入库时间
        factoryIngoods: '文安｜王胖子', //货源厂家
        orderIngoodsTime: this.formatDateToYmd(null,true),//订货时间
        priceIngoods: 0, //单价
        priceIngoodsSum: 0, //总价
        priceTruck: 0, //运费
        recordIngoodsTime: '',//记录时间
        truckIngoods: '货车｜大揪', //运输方式
        typeIngoods: '紫铜',// 货物类型
        unitIngoods: 'kg'//单位
      },
      updateUserInfo: {
        arrivalIngoodsNum: '',//入库数量
        arrivalIngoodsTime: '',//入库时间
        factoryIngoods: '', //货源厂家
        orderIngoodsTime: '',//订货时间
        priceIngoods: '', //单价
        priceIngoodsSum: '', //总价
        priceTruck: '', //运费
        recordIngoodsTime: '',//记录时间
        truckIngoods: '', //运输方式
        typeIngoods: '',// 货物类型
        unitIngoods: 'kg'//单位
      },

      // 添加用户表单验证规则对象
      userInfoRules: {
        arrivalIngoodsTime: [
          { required: true, message: '请选择入库时间', trigger: 'change' }
        ]
      },
    }
  },
  created() {
    this.getUserList()
  },
  watch: {
    // 监听新增单价变化
    "userInfo.priceIngoods"(newVal) {
      this.computeTotal("userInfo");
    },
    // 监听新增数量变化
    "userInfo.arrivalIngoodsNum"(newVal) {
      this.computeTotal("userInfo");
    },
    // 监听修改单价变化
    "updateUserInfo.priceIngoods"(newVal) {
      this.computeTotal("updateUserInfo");
    },
    // 监听修改数量变化
    "updateUserInfo.arrivalIngoodsNum"(newVal) {
      this.computeTotal("updateUserInfo");
    }
  },
  methods: {
    // 封装日期格式化函数（复用之前的逻辑）
    formatDateToYmd(date, needTime){
      const targetDate = date || new Date();
      const year = targetDate.getFullYear();
      const month = String(targetDate.getMonth() + 1).padStart(2, '0');
      const day = String(targetDate.getDate()).padStart(2, '0');
      const hours = String(targetDate.getHours()).padStart(2, '0');
      const minutes = String(targetDate.getMinutes()).padStart(2, '0');
      const seconds = String(targetDate.getSeconds()).padStart(2, '0');

      if (needTime) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        return `${year}-${month}-${day}`;
      }
    },
    // 获取数据列表
    async getUserList() {
      const {data: res} = await $httpREQUEST.get('/api/ingoods/getdata', {params: PUBTOOLS.addParams(this.queryInfo)})
      if (res.status !== 0) return this.$message.error('获取数据失败')
      this.userList = res.userList
      this.total = res.total
      this.totalArrivalIngoodsNum = res.totalArrivalIngoodsNum || '0.00'
    },
    // 类型筛选变化
    handleTypeChange() {
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    // 入库时间范围变化
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.queryInfo.startDate = val[0]
        this.queryInfo.endDate = val[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    // 重置搜索条件
    resetSearch() {
      this.queryInfo.query = ''
      this.queryInfo.typeIngoods = ''
      this.queryInfo.startDate = ''
      this.queryInfo.endDate = ''
      this.dateRange = []
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    // 监听分页 pageSize 变化
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 监听分页 pageNum 变化
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },
    // 监听添加用户对话框关闭
    addDialogClose() {
      // 重置表单数据
      this.$refs.userInfoRef.resetFields()
    },
    // 监听添加用户对话框关闭
    editDialogClose() {
      // 重置表单数据
      this.$refs.editUserInfoRef.resetFields()
    },
    // 添加数据
    addUser() {
      this.$refs.userInfoRef.validate(async valid => {
        if (!valid) return

        this.userInfo._id = new Date().getTime().toString();
        this.userInfo._openid = "admin";
        this.userInfo.recordIngoodsTime = this.formatDateToYmd(null, true); // 更新记录时间
        this.userInfo.orderIngoodsTime = this.formatDateToYmd(null, true); // 订货时间字段未启用

        const {data: res} = await $httpREQUEST.post('/api/ingoods/register', this.userInfo)
        if (res.status !== 0) return this.$message.error(res.message)
        this.$message.success('添加记录成功')
        this.dialogVisible = false
        await this.getUserList()
      })
    },
    // 删除用户
    async deleteUser(_id) {
      const confirmResult = await this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('已取消删除')
      const {data: res} = await $httpREQUEST.delete('/api/delIngoods', {params: PUBTOOLS.addParams({_id: _id})})
      if (res.status !== 0) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      await this.getUserList()
    },
    // 显示编辑用户对话框
    updateUser(rowData) {

      this.updateUserInfo._id = rowData._id;
      this.updateUserInfo._openid = rowData._openid;
      this.updateUserInfo.arrivalIngoodsNum = rowData.arrivalIngoodsNum;//入库数量
      this.updateUserInfo.arrivalIngoodsTime = rowData.arrivalIngoodsTime;//
      this.updateUserInfo.factoryIngoods = rowData.factoryIngoods;//
      this.updateUserInfo.orderIngoodsTime = rowData.orderIngoodsTime;//
      this.updateUserInfo.priceIngoods = rowData.priceIngoods;//
      this.updateUserInfo.priceIngoodsSum = rowData.priceIngoodsSum;//
      this.updateUserInfo.priceTruck = rowData.priceTruck;//
      this.updateUserInfo.recordIngoodsTime = rowData.orderIngoodsTime; // 修改后也不更新记录时间
      this.updateUserInfo.truckIngoods = rowData.truckIngoods;//
      this.updateUserInfo.typeIngoods = rowData.typeIngoods;//
      this.updateUserInfo.unitIngoods = rowData.unitIngoods;//

      this.editDialogVisible = true
    },
    async editUser() {
      await $httpREQUEST.post('/api/editIngoodsInfo', this.updateUserInfo)
      this.editDialogVisible = false
      await this.getUserList()
      this.$message.success('更新用户信息成功')
    },
    // 计算总价 = 单价 × 数量
    computeTotal(dataType) {
      const price = parseFloat(this[dataType].priceIngoods) || 0;
      const num = parseFloat(this[dataType].arrivalIngoodsNum) || 0;
      this[dataType].priceIngoodsSum = (price * num).toFixed(2); // 保留2位小数
    }
  }
}
</script>

<style scoped>
  /* 筛选表单样式 */
  .search-form {
    margin-bottom: 0;
    padding: 6px 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  .search-form >>> .el-form-item {
    margin-bottom: 0;
    margin-right: 4px;
  }
  .search-form >>> .el-form-item__label {
    font-weight: 500;
    color: #606266;
    padding-right: 2px;
    font-size: 12px;
    width:80px;
  }
  .search-form >>> .el-input__inner,
  .search-form >>> .el-range-editor.el-input__inner {
    font-size: 12px;
    padding: 0 4px;
  }
  .search-form >>> .el-range-editor .el-range-input {
    font-size: 12px;
  }
  .search-form >>> .el-range-editor .el-range-separator {
    font-size: 12px;
    padding: 0 2px;
    width: auto;
  }
  /* 强制筛选框宽度生效（覆盖 Element UI 默认宽度） */
  .search-form >>> .el-input {
    width: 180px !important;
  }
  .search-form >>> .el-select {
    width: 165px !important;
  }
  .search-form >>> .el-date-editor.el-range-editor {
    width: 255px !important;
  }

  /* 操作与统计栏 */
  .action-bar {
    margin-top: 10px;
    margin-bottom: 10px;
    align-items: center;
    padding: 8px 12px;
    background-color: #fafafa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  .stats-col {
    text-align: right;
  }

  /* 表格样式 */
  .ingoods-table {
    margin-bottom: 10px;
  }
  .ingoods-table >>> .el-table__header th {
    background-color: #f5f7fa;
    color: #303133;
    font-weight: 600;
    font-size: 13px;
    padding: 6px 0;
  }
  .ingoods-table >>> .el-table__body td {
    font-size: 13px;
    padding: 5px 0;
  }

  /* 分页样式 */
  .el-pagination {
    margin-top: 10px;
    text-align: right;
  }

  /* 操作列按钮紧凑样式 */
  .ingoods-table >>> .compact-actions .cell {
    padding: 0 2px;
    white-space: nowrap;
  }
  .ingoods-table >>> .compact-actions .action-btn {
    padding: 5px 6px;
    margin-left: 2px;
    min-width: 28px;
  }
  .ingoods-table >>> .compact-actions .action-btn:first-child {
    margin-left: 0;
  }
</style>
<style lang="less" scoped></style>
